import React from 'react';
import './HighlightToolbar.css';

const HIGHLIGHT_COLORS = [
  { name: 'Yellow', value: '#FCE38A' },
  { name: 'Green', value: '#95E1D3' },
  { name: 'Blue', value: '#4ECDC4' },
  { name: 'Pink', value: '#F38181' },
  { name: 'Orange', value: '#FFB347' },
  { name: 'Purple', value: '#AA96DA' },
  { name: 'Red', value: '#FF6B6B' },
  { name: 'Cyan', value: '#85C1E2' }
];

const HighlightToolbar = ({ selectedColor, onColorSelect, onCancel }) => {
  return (
    <div className="highlight-toolbar">
      <div className="toolbar-section">
        <label>Highlight color:</label>
        <div className="color-picker">
          {HIGHLIGHT_COLORS.map(color => (
            <button
              key={color.value}
              className={`color-btn ${selectedColor === color.value ? 'active' : ''}`}
              style={{ backgroundColor: color.value }}
              onClick={() => onColorSelect(color.value)}
              title={color.name}
            />
          ))}
        </div>
      </div>
      <button className="cancel-highlight-btn" onClick={onCancel} type="button">
        Cancel Highlight
      </button>
    </div>
  );
};

export default HighlightToolbar;
export { HIGHLIGHT_COLORS };
